/**
 * Inline quick-add size picker for product cards.
 *
 * Tapping the cart button on a product card reveals the product's size
 * options overlaid on the image (bond-eye style). Picking a size writes the
 * chosen variant onto the card's product form and submits it — the theme's
 * <product-form> element handles the AJAX add-to-cart and opens the cart
 * drawer (via the on_success=force_open_drawer input).
 *
 * Uses event delegation on the document so it keeps working for cards that
 * are injected after load (e.g. collection filtering / infinite scroll).
 */
(function () {
  'use strict';

  var WRAPPER = '.product-card__quick-add';
  var OPEN = 'is-open';

  function getPicker(wrapper) {
    return wrapper.querySelector('[data-size-picker]');
  }

  function getToggle(wrapper) {
    return wrapper.querySelector('[data-quick-add-toggle]');
  }

  function close(wrapper) {
    if (!wrapper || !wrapper.classList.contains(OPEN)) return;
    wrapper.classList.remove(OPEN);
    var picker = getPicker(wrapper);
    var toggle = getToggle(wrapper);
    if (picker) picker.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    var open = document.querySelectorAll(WRAPPER + '.' + OPEN);
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) close(open[i]);
    }
  }

  function open(wrapper) {
    closeAll(wrapper);
    wrapper.classList.add(OPEN);
    var picker = getPicker(wrapper);
    var toggle = getToggle(wrapper);
    if (picker) picker.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', function (event) {
    // 1. Cart button toggles the picker open/closed
    var toggle = event.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      event.preventDefault();
      var toggleWrapper = toggle.closest(WRAPPER);
      if (!toggleWrapper) return;
      if (toggleWrapper.classList.contains(OPEN)) close(toggleWrapper);
      else open(toggleWrapper);
      return;
    }

    // 2. A size option adds that variant to the cart
    var option = event.target.closest('[data-variant-id]');
    if (option && !option.disabled) {
      event.preventDefault();
      var optionWrapper = option.closest(WRAPPER);
      if (!optionWrapper) return;
      var form = optionWrapper.querySelector('form');
      var input = optionWrapper.querySelector('[data-variant-id-input]');
      if (form && input) {
        input.value = option.getAttribute('data-variant-id');
        close(optionWrapper);
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
      return;
    }

    // 3. A click anywhere else closes any open picker
    if (!event.target.closest(WRAPPER)) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') closeAll(null);
  });
})();
